import * as actionTypes from './actions/actionTypes';
import { updateObject } from '../global/utility';

const initialState = {
    loading_playlists: false,
    playlists: [],
    creating_playlist: false,
    selected_playlist: null,
    loading_devices: false,
    devices: [],
    selected_device: null,
    media_library_is_selected: false,
    pairing_new_device: false,
    submitting_code: false,
    media: [],
    loading_media: false,
    selected_media: null,
    uploading_media: false,
    attaching_media: false,
    deleting_device: false,
    saving_media: false,
    deleting_media: false,
    exporting_playlist: false,
    // Series art (#482)
    series_art: null,
    loading_series_art: false,
    updating_series_art: false,
    uploading_series_art: false,
    // Per-playlist series art (#482)
    updating_playlist_series_art: false,
    uploading_playlist_series_art: false,
    series_art_service_types: [],
    loading_series_art_service_types: false,
}


const playlistsStart = (state, action) => {
    return updateObject(state, { loading_playlists: true });
};

const playlistsSuccess = (state, action) => {
    return updateObject(state, { playlists: action.details, loading_playlists: false });
};

const playlistsFailure = (state, action) => {
    return updateObject(state, { loading_playlists: false });
};

const selectPlaylistFinish = (state, action) => {
    return updateObject(state, { selected_playlist: action.playlist, selected_device: null, media_library_is_selected: false });
};

const createPlaylistStart = (state, action) => {
    return updateObject(state, { creating_playlist: true, selected_playlist: null });
};

const createPlaylistSuccess = (state, action) => {
    return updateObject(state, { creating_playlist: false, selected_playlist: action.details, playlists: [...state.playlists, action.details] });
};

const createPlaylistFailure = (state, action) => {
    return updateObject(state, { creating_playlist: false });
};

const deletePlaylistStart = (state, action) => {
    return updateObject(state, { deleting_playlist: true });
};

const deletePlaylistSuccess = (state, action) => {
    return updateObject(state, { deleting_playlist: false, playlists: state.playlists.filter(playlist => playlist.id !== action.details.id) });
};

const deletePlaylistFailure = (state, action) => {
    return updateObject(state, { deleting_playlist: false });
};


const exportPlaylistStart = (state, action) => {
    return updateObject(state, { exporting_playlist: true });
};

const exportPlaylistSuccess = (state, action) => {
    return updateObject(state, { exporting_playlist: false });
};

const exportPlaylistFailure = (state, action) => {
    return updateObject(state, { exporting_playlist: false });
};


const fetchDevicesStart = (state, action) => {
    return updateObject(state, { loading_devices: true });
};

const fetchDevicesSuccess = (state, action) => {
    return updateObject(state, { devices: action.details, loading_devices: false });
};

const fetchDevicesFailure = (state, action) => {
    return updateObject(state, { loading_devices: false });
};


const selectDeviceFinish = (state, action) => {
    return updateObject(state, { selected_device: action.device, selected_playlist: null, media_library_is_selected: false });
};

const pairNewDeviceFinish = (state, action) => {
    return updateObject(state, { pairing_new_device: true, selected_device: null, selected_playlist: null, media_library_is_selected: false });
};

const submitCodeStart = (state, action) => {
    return updateObject(state, { submitting_code: true });
};

const submitCodeSuccess = (state, action) => {
    return updateObject(state, { submitting_code: false, pairing_new_device: false });
};

const submitCodeFailure = (state, action) => {
    return updateObject(state, { submitting_code: false });
};

const selectMediaLibraryFinish = (state, action) => {
    return updateObject(state, { media_library_is_selected: true, selected_device: null, selected_playlist: null });
};

const fetchMediaStart = (state, action) => {
    return updateObject(state, { loading_media: true });
};


const fetchMediaSuccess = (state, action) => {
    return updateObject(state, { media: action.details, loading_media: false });
};


const fetchMediaFailure = (state, action) => {
    return updateObject(state, { loading_media: false });
};


const selectMediaFinish = (state, action) => {
    return updateObject(state, { selected_media: action.media });
};


const selectDeviceByIDFinish = (state, action) => {
    return updateObject(state, { selected_device: state.devices.find((item) => item.id == action.device_id) });
};

const selectPlaylistByIDFinish = (state, action) => {
    return updateObject(state, { selected_playlist: state.playlists.find((item) => item.id == action.playlist_id) });
};


const deleteDeviceStart = (state, action) => {
    return updateObject(state, { deleting_device: true });
};

const deleteDeviceSuccess = (state, action) => {
    return updateObject(state, { deleting_device: false, devices: state.devices.filter(device => device.id !== action.details.id) });
};

const deleteDeviceFailure = (state, action) => {
    return updateObject(state, { deleting_device: false });
};

const updateDeviceStart = (state, action) => {
    return updateObject(state, { updating_device: true });
};

const updateDeviceSuccess = (state, action) => {
    const updated = action.details;
    return updateObject(state, {
        updating_device: false,
        selected_device: state.selected_device && state.selected_device.id === updated.id ? updated : state.selected_device,
        devices: state.devices.map(device => device.id === updated.id ? updated : device),
    });
};

const updateDeviceFailure = (state, action) => {
    return updateObject(state, { updating_device: false });
};

const uploadMediaStart = (state, action) => {
    return updateObject(state, { uploading_media: true });
};

const uploadMediaSuccess = (state, action) => {
    return updateObject(state, { uploading_media: false });
};

const uploadMediaFailure = (state, action) => {
    return updateObject(state, { uploading_media: false });
};


const attachMediaStart = (state, action) => {
    return updateObject(state, { attaching_media: true });
};

const attachMediaSuccess = (state, action) => {
    return updateObject(state, { attaching_media: false });
};

const attachMediaFailure = (state, action) => {
    return updateObject(state, { attaching_media: false });
};

const saveMediaStart = (state, action) => {
    return updateObject(state, { saving_media: true });
};

const saveMediaSuccess = (state, action) => {
    return updateObject(state, { saving_media: false });
};


const saveMediaFailure = (state, action) => {
    return updateObject(state, { saving_media: false });
};


const deleteMediaStart = (state, action) => {
    return updateObject(state, { deleting_media: true });
};


const deleteMediaSuccess = (state, action) => {
    return updateObject(state, { deleting_media: false, media: state.media.filter(media => media.id !== action.details.id) });
};


const deleteMediaFailure = (state, action) => {
    return updateObject(state, { deleting_media: false });
};


const deleteMediaFromPlaylistStart = (state, action) => {
    return updateObject(state, { deleting_media_from_playlist: true });
};


const deleteMediaFromPlaylistSuccess = (state, action) => {
    return updateObject(state, { deleting_media_from_playlist: false });
};



const deleteMediaFromPlaylistFailure = (state, action) => {
    return updateObject(state, { deleting_media_from_playlist: false });
};



const fetchSeriesArtStart = (state, action) => {
    return updateObject(state, { loading_series_art: true });
};

const fetchSeriesArtSuccess = (state, action) => {
    return updateObject(state, { series_art: action.details, loading_series_art: false });
};

const fetchSeriesArtFailure = (state, action) => {
    return updateObject(state, { loading_series_art: false });
};

const updateSeriesArtStart = (state, action) => {
    return updateObject(state, { updating_series_art: true });
};

const updateSeriesArtSuccess = (state, action) => {
    return updateObject(state, { updating_series_art: false, series_art: action.details });
};

const updateSeriesArtFailure = (state, action) => {
    return updateObject(state, { updating_series_art: false });
};

const uploadSeriesArtStart = (state, action) => {
    return updateObject(state, { uploading_series_art: true });
};

const uploadSeriesArtSuccess = (state, action) => {
    return updateObject(state, { uploading_series_art: false, series_art: action.details });
};

const uploadSeriesArtFailure = (state, action) => {
    return updateObject(state, { uploading_series_art: false });
};

// ---- Per-playlist series art (#482) --------------------------------------
//
// Every success replaces `selected_playlist` and the matching row in
// `playlists` with the server's payload. The playlist editor renders
// off `selected_playlist`, so a toggle/connect/upload round-trip is
// visible immediately without a follow-up `selectPlaylistByID` fetch.
const replacePlaylistInList = (playlists, updated) => {
    if (!Array.isArray(playlists) || !updated) return playlists;
    return playlists.map(p => (p.id === updated.id ? updated : p));
};

const updatePlaylistSeriesArtStart = (state, action) => {
    return updateObject(state, { updating_playlist_series_art: true });
};

const updatePlaylistSeriesArtSuccess = (state, action) => {
    return updateObject(state, {
        updating_playlist_series_art: false,
        selected_playlist: action.details,
        playlists: replacePlaylistInList(state.playlists, action.details),
    });
};

const updatePlaylistSeriesArtFailure = (state, action) => {
    return updateObject(state, { updating_playlist_series_art: false });
};

const uploadPlaylistSeriesArtStart = (state, action) => {
    return updateObject(state, { uploading_playlist_series_art: true });
};

const uploadPlaylistSeriesArtSuccess = (state, action) => {
    return updateObject(state, {
        uploading_playlist_series_art: false,
        selected_playlist: action.details,
        playlists: replacePlaylistInList(state.playlists, action.details),
    });
};

const uploadPlaylistSeriesArtFailure = (state, action) => {
    return updateObject(state, { uploading_playlist_series_art: false });
};

const fetchSeriesArtServiceTypesStart = (state, action) => {
    return updateObject(state, { loading_series_art_service_types: true });
};

const fetchSeriesArtServiceTypesSuccess = (state, action) => {
    return updateObject(state, {
        loading_series_art_service_types: false,
        series_art_service_types: action.details || [],
    });
};

const fetchSeriesArtServiceTypesFailure = (state, action) => {
    return updateObject(state, { loading_series_art_service_types: false });
};


const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.FETCH_PLAYLISTS_START: return playlistsStart(state, action);            
        case actionTypes.FETCH_PLAYLISTS_SUCCESS: return playlistsSuccess(state, action);            
        case actionTypes.FETCH_PLAYLISTS_FAILURE: return playlistsFailure(state, action);
        case actionTypes.SELECT_PLAYLIST: return selectPlaylistFinish(state, action);
        case actionTypes.CREATE_PLAYLIST_START: return createPlaylistStart(state, action);
        case actionTypes.CREATE_PLAYLIST_SUCCESS: return createPlaylistSuccess(state, action);
        case actionTypes.CREATE_PLAYLIST_FAILURE: return createPlaylistFailure(state, action);
        case actionTypes.DELETE_PLAYLIST_START: return deletePlaylistStart(state, action);
        case actionTypes.DELETE_PLAYLIST_SUCCESS: return deletePlaylistSuccess(state, action);
        case actionTypes.DELETE_PLAYLIST_FAILURE: return deletePlaylistFailure(state, action);
        case actionTypes.EXPORT_PLAYLIST_START: return exportPlaylistStart(state, action);
        case actionTypes.EXPORT_PLAYLIST_SUCCESS: return exportPlaylistSuccess(state, action);
        case actionTypes.EXPORT_PLAYLIST_FAILURE: return exportPlaylistFailure(state, action);
        case actionTypes.FETCH_DEVICES_START: return fetchDevicesStart(state, action);            
        case actionTypes.FETCH_DEVICES_SUCCESS: return fetchDevicesSuccess(state, action);            
        case actionTypes.FETCH_DEVICES_FAILURE: return fetchDevicesFailure(state, action);
        case actionTypes.SELECT_DEVICE: return selectDeviceFinish(state, action);
        case actionTypes.PAIR_NEW_DEVICE: return pairNewDeviceFinish(state, action);
        case actionTypes.SUBMIT_CODE_START: return submitCodeStart(state, action);
        case actionTypes.SUBMIT_CODE_SUCCESS: return submitCodeSuccess(state, action);
        case actionTypes.SUBMIT_CODE_FAILURE: return submitCodeFailure(state, action);
        case actionTypes.SELECT_MEDIA_LIBRARY: return selectMediaLibraryFinish(state, action);
        case actionTypes.FETCH_MEDIA_START: return fetchMediaStart(state, action);
        case actionTypes.FETCH_MEDIA_SUCCESS: return fetchMediaSuccess(state, action);
        case actionTypes.FETCH_MEDIA_FAILURE: return fetchMediaFailure(state, action);
        case actionTypes.SAVE_MEDIA_START: return saveMediaStart(state, action);
        case actionTypes.SAVE_MEDIA_SUCCESS: return saveMediaSuccess(state, action);
        case actionTypes.SAVE_MEDIA_FAILURE: return saveMediaFailure(state, action);
        case actionTypes.DELETE_MEDIA_START: return deleteMediaStart(state, action);
        case actionTypes.DELETE_MEDIA_SUCCESS: return deleteMediaSuccess(state, action);
        case actionTypes.DELETE_MEDIA_FAILURE: return deleteMediaFailure(state, action);
        case actionTypes.DELETE_MEDIA_FROM_PLAYLIST_START: return deleteMediaFromPlaylistStart(state, action);
        case actionTypes.DELETE_MEDIA_FROM_PLAYLIST_SUCCESS: return deleteMediaFromPlaylistSuccess(state, action);
        case actionTypes.DELETE_MEDIA_FROM_PLAYLIST_FAILURE: return deleteMediaFromPlaylistFailure(state, action);
        case actionTypes.SELECT_MEDIA: return selectMediaFinish(state, action);
        case actionTypes.SELECT_DEVICE_BY_ID: return selectDeviceByIDFinish(state, action);
        case actionTypes.SELECT_PLAYLIST_BY_ID: return selectPlaylistByIDFinish(state, action);
        case actionTypes.DELETE_DEVICE_START: return deleteDeviceStart(state, action);
        case actionTypes.DELETE_DEVICE_SUCCESS: return deleteDeviceSuccess(state, action);
        case actionTypes.DELETE_DEVICE_FAILURE: return deleteDeviceFailure(state, action);
        case actionTypes.UPDATE_DEVICE_START: return updateDeviceStart(state, action);
        case actionTypes.UPDATE_DEVICE_SUCCESS: return updateDeviceSuccess(state, action);
        case actionTypes.UPDATE_DEVICE_FAILURE: return updateDeviceFailure(state, action);
        case actionTypes.UPLOAD_MEDIA_START: return uploadMediaStart(state, action);
        case actionTypes.UPLOAD_MEDIA_SUCCESS: return uploadMediaSuccess(state, action);
        case actionTypes.UPLOAD_MEDIA_FAILURE: return uploadMediaFailure(state, action);
        case actionTypes.ATTACH_MEDIA_START: return attachMediaStart(state, action);
        case actionTypes.ATTACH_MEDIA_SUCCESS: return attachMediaSuccess(state, action);
        case actionTypes.ATTACH_MEDIA_FAILURE: return attachMediaFailure(state, action);
        case actionTypes.FETCH_SERIES_ART_START: return fetchSeriesArtStart(state, action);
        case actionTypes.FETCH_SERIES_ART_SUCCESS: return fetchSeriesArtSuccess(state, action);
        case actionTypes.FETCH_SERIES_ART_FAILURE: return fetchSeriesArtFailure(state, action);
        case actionTypes.UPDATE_SERIES_ART_START: return updateSeriesArtStart(state, action);
        case actionTypes.UPDATE_SERIES_ART_SUCCESS: return updateSeriesArtSuccess(state, action);
        case actionTypes.UPDATE_SERIES_ART_FAILURE: return updateSeriesArtFailure(state, action);
        case actionTypes.UPLOAD_SERIES_ART_START: return uploadSeriesArtStart(state, action);
        case actionTypes.UPLOAD_SERIES_ART_SUCCESS: return uploadSeriesArtSuccess(state, action);
        case actionTypes.UPLOAD_SERIES_ART_FAILURE: return uploadSeriesArtFailure(state, action);
        case actionTypes.UPDATE_PLAYLIST_SERIES_ART_START: return updatePlaylistSeriesArtStart(state, action);
        case actionTypes.UPDATE_PLAYLIST_SERIES_ART_SUCCESS: return updatePlaylistSeriesArtSuccess(state, action);
        case actionTypes.UPDATE_PLAYLIST_SERIES_ART_FAILURE: return updatePlaylistSeriesArtFailure(state, action);
        case actionTypes.UPLOAD_PLAYLIST_SERIES_ART_START: return uploadPlaylistSeriesArtStart(state, action);
        case actionTypes.UPLOAD_PLAYLIST_SERIES_ART_SUCCESS: return uploadPlaylistSeriesArtSuccess(state, action);
        case actionTypes.UPLOAD_PLAYLIST_SERIES_ART_FAILURE: return uploadPlaylistSeriesArtFailure(state, action);
        case actionTypes.FETCH_SERIES_ART_SERVICE_TYPES_START: return fetchSeriesArtServiceTypesStart(state, action);
        case actionTypes.FETCH_SERIES_ART_SERVICE_TYPES_SUCCESS: return fetchSeriesArtServiceTypesSuccess(state, action);
        case actionTypes.FETCH_SERIES_ART_SERVICE_TYPES_FAILURE: return fetchSeriesArtServiceTypesFailure(state, action);
        default: return state;
    }
};

export default reducer;